import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const loadBanks = createAsyncThunk(
    'manageBanks/loadBanks',
    async (token) => {
        const response = fetch(`${process.env.REACT_APP_BASE_URL}/admin/banks`,
            {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const manageBanksSlice = createSlice({
    name: 'manageBanks',
    initialState: {
        banks: [],
        banksLoading: false,
        failedToLoadBanks: false
    },
    extraReducers: {
        [loadBanks.pending]: (state) => {
            return {
                ...state,
                banksLoading: true,
                failedToLoadBanks: false
            }
        },
        [loadBanks.fulfilled]: (state, action) => {
            return {
                ...state,
                banksLoading: false,
                failedToLoadBanks: false,
                banks: action.payload
            }
        },
        [loadBanks.rejected]: (state) => {
            return {
                ...state,
                banksLoading: false,
                failedToLoadBanks: true
            }
        }
    }
})

export const selectBanks = (state) => state.manageBanks.banks;
export const banksAreLoading = (state) => state.manageBanks.banksLoading;
export const loadBanksFailed = (state) => state.manageBanks.failedToLoadBanks;

export default manageBanksSlice.reducer;